import React from "react";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import { Row, Col, Panel } from "react-bootstrap";
import { connect } from "react-redux";
import { engineer } from "../../../selectors/engineers";
import {
  engineerPageLoad,
  engineerAddRequest,
} from "../../../actions/engineers";
import { push } from "react-router-redux";
import EngineerForm from "../../../components/forms/Engineer";
import { regionsAvailableToEngineers } from "../../../selectors/regions";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default connect(
  (state, ownProps) => ({
    engineer: engineer(state),
    regions: regionsAvailableToEngineers(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(engineerPageLoad()),
    onSave: formData => dispatch(engineerAddRequest(formData)),
    onEngineerList: () => dispatch(push("/engineers")),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.engineer === null) return <div />;
    return (
      <div id="add-engineer-page">
        <PageTitle title="Create Engineer" />
        <div>
          <a
            id="back"
            style={{ cursor: "pointer" }}
            onClick={props.onEngineerList}
          >
            <span className="glyphicon  glyphicon-circle-arrow-left" />
            Back to engineers list
          </a>
        </div>
        <br />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Engineer data</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <EngineerForm
                  engineer={props.engineer}
                  regions={props.regions}
                  onSave={props.onSave}
                  disabled={props.engineer.generalDataSaveInProgress}
                  backendError={props.engineer.generalDataError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/engineers/Add.js